import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DoctorSocialService } from '../doctor-social.service';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';

export enum reportType {
  DontLikeIt = 1,
  Spam = 2,
  SexualActivity = 3,
  HateSpeach = 4,
  Violance = 5,
  Bullying = 6,
  FalseInformation = 7
}


@Component({
  selector: 'app-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.css']
})
export class ReportDialogComponent implements OnInit {

  reportType = reportType

  ObjFiltered = [
    { nameAr: "فقط لم يعجبني", name: "I just don't like it", id: reportType.DontLikeIt },
    { nameAr: "منشور مزعج", name: "It's a spam", id: reportType.Spam },
    { nameAr: "منشور عري أو خادش للحياء", name: "Nudity or sexual activity", id: reportType.SexualActivity },
    { nameAr: "منشور يحرض على خطاب الكراهية", name: "Hate speech or a symbol", id: reportType.HateSpeach },
    { nameAr: "منشور يحرض على العنف", name: "Violence or dangerous organization", id: reportType.Violance },
    { nameAr: "التنمر أو التحرش", name: "Bullying or harassment", id: reportType.Bullying },
    { nameAr: "معلومات خاطئة", name: "False information", id: reportType.FalseInformation },
  ]

  constructor(
    public dialogRef: MatDialogRef<ReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private service: DoctorSocialService,
    private toaster: ToastrService,
    public app: AppService
  ) { }

  ngOnInit(): void {
    // this.getInterests();
  }

  getInterests() {
    // this.service.getCategories().subscribe(
    //   res => {

    //   }
    // )
  }

  cancel(): void {
    this.dialogRef.close();
  }

  selected = null;
  onChangeSelection(e, obj) {
    this.selected = e?.source?.value
    console.warn(e?.source?.value)
    // console.warn(e?.checked)

    // if (e?.checked) {
    //   this.selectedChips.push(obj)
    // } else if (!e?.checked) {
    //   this.removeChip(obj)
    // }
  }

  submitReport() {
    if (!this.selected) {
      if (this?.app?.getUserLanguage() == 'en') {
        this.toaster.info("Select a Reason");
      } else if (this?.app?.getUserLanguage() == 'ar') {
        this.toaster.success("الرجاء الإختيار");
      }
      return
    }
    let request = new FormData();
    // request.append("CommentId", "");
    request.append("ReportType", this.selected);
    this.service.reportPost(request, this?.data?.id).subscribe(
      res => {
        if (res.errorCode == 0) {
          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.success("Reported Successfully");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.success("تم الإبلاغ");
          }
          this.dialogRef.close(null)
        } else {
          this.toaster.error(res?.errorMessage);
          // if (this?.app?.getUserLanguage() == 'en') {
          // } else if (this?.app?.getUserLanguage() == 'ar') {
          //   this.toaster.error("حدث خطأ ما");
          // }
          this.dialogRef.close(null)
        }
      }
    )
  }

}
